<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg my-npa-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                        dark
                        v-on="on"
                        class="navbar-toggler-profile"
                        :aria-label="$t('Открыть меню профиля')"
                >
                  {{ $t("Профиль") }} <span class="caret" aria-hidden="true"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="search-head">
              <MyNpaSearch
                v-bind:search="search"
                v-bind:developers="developers"
                v-bind:statuses="statuses"
                v-bind:views="views"
                v-bind:types="types"
                @search-npa="getDataSearch($event)"
                @reset-npa="resetDataSearch($event)"
              />
            </div>
            <div class="private-section mt-4">
              <div class="table-overflow">
                <v-simple-table v-if="items.length">
                  <thead>
                  <tr>
                    <th v-for="(value, field) in tableFields" :key="field">
                      <a href="#" :aria-label="$t('Сортировать') + ': ' + value" @click.prevent="sortData(field)">
                        <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>
                        {{ value }}
                      </a>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td class="td-num">{{ item.id }}</td>
                    <td class="td-view">{{ item.view.transName }}</td>
                    <td class="td-name">
                      <router-link
                        :title="item.transProjectGoal | strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'npa-view',
                          params: { id: item.id }
                        })"
                      >
                        {{ item.transName }}
                      </router-link>
                    </td>
                    <td class="td-category">
                      <span v-for="(category, key) in item.category" :key="category.id">
                        <span v-if="key !== 0">, </span>{{ category.transName }}
                      </span>
                    </td>
                    <td class="td-status">{{ item.status.transName }}</td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </div>
              <div class="private-footer">
                <p>{{ $t("Общее количество НПА") }}: {{ itemsTotal }}</p>
              </div>

              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="7"
                :aria-label="$t('Страницы результатов поиска')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Widget from '@/components/app/Widget'
import Npa from '@/model/npa'
import MyNpaSearch from "@/components/npa/MyNpaSearch"
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    MyNpaSearch,
    Widget
  },
  data: () => ({
    breadcrumbs: [],
    tableFields: {},
    search: {},
    developers: [],
    statuses: [],
    views: [],
    types: [],
    sortSettings: {
      view: null,
      name: null,
      category: null,
      status: null
    },
    items: [],
    itemsTotal: 0,
    page: 1,
    pagesCount: 1
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData',
    page() {
      this.searchNpa()
    }
  },
  created() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.searchNpa()
      this.breadcrumbs = [
        { text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile' },
        { text: this.$i18n.t('Мои проекты НПА'), disabled: true }
      ]
      this.tableFields = {
        id: this.$i18n.t('ID проекта'),
        view: this.$i18n.t('Вид проекта НПА'),
        name: this.$i18n.t('Наименование'),
        category: this.$i18n.t('Категории'),
        status: this.$i18n.t('Статус')
      }
      Npa.getFilterFormData()
        .then((response) => {
          this.developers = response.data.refDeveloper
          this.statuses = response.data.refNpaStatus
          this.views = response.data.refNpaView
          this.types = [
            { id: 'my', name: this.$i18n.t('Мои НПА') },
            { id: 'all', name: this.$i18n.t('Все НПА') },
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    sortData(sortKey) {
      if (
        !this.sortSettings[sortKey] ||
        this.sortSettings[sortKey] === 'desc'
      ) {
        this.sortSettings[sortKey] = 'asc'
      } else {
        this.sortSettings[sortKey] = 'desc'
      }

      this.page = 1
      this.search = {...this.search, ...{page: this.page, orderBy: sortKey, orderDir: this.sortSettings[sortKey]}}
      this.searchNpa()
    },
    searchNpa() {
      this.setLoading(true)
      this.search.page = this.page

      Npa.getList(this.search)
        .then((response) => {
          this.items = response.data.items
          const paginator = response.data.paginationData
          this.itemsTotal = paginator.totalCount
          this.pagesCount = paginator.pageCount
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    //очищаем данные с формы поиска
    resetDataSearch() {
      this.search = {}
      this.page = 1
      this.fetchData()
    },
    //получаем данные с формы поиска
    getDataSearch(search) {
      this.search = {...this.search, ...search}
      this.page = 1
      this.searchNpa()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.td-num {
  width: 5%;
}
.td-view {
  width: 10%;
}
.td-name {
  width: 45%;
}
.td-category {
  width: 25%;
}
.td-status {
  width: 15%;
}
</style>
